import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import WatchImageLayer from "./watch-image-layer";
import InitialsLayer from "./initials-layer";
import TransparentImage from "../../images/customisation-assets/Transparent_Image.png";
import { preloadImage } from "../../support/preload-image";

const propTypes = {
  options: PropTypes.instanceOf(Object),
  viewIndex: PropTypes.number.isRequired,
};

const WatchFront = ({ options, viewIndex }) => {
  const layers = Object.keys(options).filter((key) => key !== "engraving");
  const [watchLayerSize, setWatchLayerSize] = useState({
    height: 0,
    width: 0,
  });

  useEffect(() => {
    async function getAndSetWatchLayerSize() {
      // Wait for transparent image to load
      await preloadImage(TransparentImage);
      const watchLayer = document.getElementById("watch-layer");
      setWatchLayerSize({
        height: watchLayer ? watchLayer.clientHeight : 0,
        width: watchLayer ? watchLayer.clientWidth : 0,
      });
    }

    getAndSetWatchLayerSize();
    window.addEventListener("resize", getAndSetWatchLayerSize);
  }, [viewIndex]);

  return (
    <>
      {layers.map((key) => (
        <>
          {key === "initials" ? (
            <InitialsLayer
              key={key}
              layerSize={watchLayerSize}
              initialsState={options[key]}
              viewIndex={viewIndex}
            />
          ) : (
            <WatchImageLayer
              key={key}
              customisationType={key}
              optionName={options[key].selected}
              viewIndex={viewIndex}
            />
          )}
        </>
      ))}
      <img
        src={TransparentImage}
        alt=""
        className={`${viewIndex === 0 ? "absolute max-h-full" : "absolute max-h-x2"}`}
        id="watch-layer"
      />
    </>
  );
};

WatchFront.propTypes = propTypes;

export default WatchFront;
